export const Appliance = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19 13H5C3.343 13 2 11.657 2 10V6C2 4.343 3.343 3 5 3H19C20.657 3 22 4.343 22 6V10C22 11.657 20.657 13 19 13Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18 6H16"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18 13V12C18 10.895 17.105 10 16 10H8C6.895 10 6 10.895 6 12V13"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 19.5V21"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.25 18.75L16.5 18"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.75 18.75L7.5 18"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Appliance</div>
    </div>
  );
};

export const Fan = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="12"
          cy="12"
          r="2.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="2"
          y="2"
          width="20"
          height="20"
          rx="5.55556"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.8689 10.3547C14.0538 9.68255 14.4992 9.11188 15.1064 8.76919C15.7135 8.42649 16.4322 8.34009 17.1033 8.52911C17.9644 8.76533 18.6416 9.43104 18.8925 10.288C19.1225 11.0616 18.9857 11.8979 18.5212 12.5579C18.3298 12.8181 18.0276 12.9738 17.7046 12.9785C17.3815 12.9832 17.0749 12.8364 16.876 12.5819C16.2507 11.781 15.3379 11.2553 14.3313 11.1163"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.1164 9.66864C11.2554 8.66209 11.7811 7.7493 12.582 7.124C12.8365 6.92507 12.9833 6.61848 12.9786 6.29546C12.9739 5.97245 12.8183 5.67025 12.5581 5.4788C11.898 5.01435 11.0617 4.87758 10.2881 5.10758C9.43108 5.3584 8.76537 6.03554 8.52916 6.89667C8.34015 7.56772 8.42656 8.28644 8.76924 8.89358C9.11191 9.50071 9.68256 9.94611 10.3547 10.1311"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.8835 14.3313C12.7446 15.3379 12.2189 16.2506 11.418 16.876C11.1635 17.0749 11.0167 17.3815 11.0214 17.7045C11.0261 18.0275 11.1817 18.3297 11.4419 18.5211C12.102 18.9856 12.9383 19.1224 13.7119 18.8924C14.5689 18.6415 15.2346 17.9644 15.4708 17.1033C15.6599 16.4322 15.5735 15.7135 15.2308 15.1063C14.8881 14.4992 14.3175 14.0537 13.6453 13.8688"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.6687 12.8835C8.66212 12.7446 7.7493 12.2189 7.124 11.418C6.92504 11.1635 6.61843 11.0168 6.29541 11.0215C5.9724 11.0262 5.6702 11.1818 5.47874 11.442C5.01424 12.102 4.87747 12.9384 5.10752 13.7119C5.35839 14.5689 6.03556 15.2347 6.89671 15.4709C7.56777 15.6599 8.28651 15.5735 8.89365 15.2308C9.50078 14.8881 9.94617 14.3174 10.1311 13.6452"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <div>Fan</div>
    </div>
  );
};
